import React from "react"

import logo from "../../../assets/images/brand/classkick-logo-rgb_small.png"

interface HeaderProps {
  isLoggedIn: boolean
  goToHomepage: () => void
  goToTeacherHelpCenter: () => void
  goToPlan: () => void
  goToLogin: () => void
  goToProfile: () => void
}

export function Header({
  isLoggedIn,
  goToHomepage,
  goToTeacherHelpCenter,
  goToPlan,
  goToLogin,
  goToProfile,
}: HeaderProps) {
  return (
    <div className="tw-h-35 tw-flex tw-items-center tw-justify-between tw-flex-none tw-shadow-sm tw-p-2 tw-pl-12">
      <div className="tw-flex tw-items-center">
        <img
          className="logo tw-cursor-pointer tw-h-8"
          onClick={goToHomepage}
          src={logo}
          alt="Classkick Logo"
        />
      </div>

      <div className="tw-flex tw-items-center">
        <div
          className="tw-cursor-pointer tw-font-semibold tw-text-sm tw-tracking-wider tw-mx-4 tw-transition tw-duration-200 tw-hover:text-green-500"
          onClick={goToTeacherHelpCenter}
        >
          TEACHER RESOURCES
        </div>

        {isLoggedIn ? (
          <div
            className="tw-cursor-pointer tw-text-green-500 tw-mx-4 tw-font-semibold tw-text-sm tw-tracking-wider"
            onClick={goToPlan}
          >
            MY PLAN
          </div>
        ) : (
          <div className="tw-text-green-500 tw-cursor-pointer tw-mx-4 tw-font-semibold tw-text-sm tw-tracking-wider">
            PURCHASE
          </div>
        )}

        {isLoggedIn ? (
          <div
            className="tw-cursor-pointer tw-font-semibold tw-text-sm tw-tracking-wider tw-mx-4 tw-transition tw-duration-200 tw-hover:text-green-500 tw-pr-12"
            onClick={goToProfile}
          >
            PROFILE
          </div>
        ) : (
          <div
            className="tw-cursor-pointer tw-font-semibold tw-text-sm tw-tracking-wider tw-mx-4 tw-transition tw-duration-200 tw-hover:text-green-500 tw-pr-12"
            onClick={goToLogin}
          >
            LOG IN
          </div>
        )}
      </div>
    </div>
  )
}
